import { useState } from 'react'
import Button from './Button.jsx'
import Popover from './Popover.jsx'
import useMediaQuery, { BREAKPOINTS } from './hooks/useMediaQuery.js'

export function Toolbar({ className = '', children, ...rest }) {
  return <div className={`cn-toolbar ${className}`.trim()} {...rest}>{children}</div>
}

export function ToolbarSpacer() {
  return <span className="cn-toolbar-spacer" />
}

// Inline on desktop/tablet; on phones the children move into a bottom sheet.
export function FilterBar({ count = 0, label = 'Filters', children }) {
  const phone = useMediaQuery(`(max-width: ${BREAKPOINTS.phone}px)`)
  const [open, setOpen] = useState(false)
  if (!phone) return <div className="cn-filterbar">{children}</div>
  return (
    <div className="cn-filterbar cn-popover-wrap">
      <Button variant="ghost" size="sm" onClick={() => setOpen(!open)}>
        {label}{count > 0 ? ` (${count})` : ''}
      </Button>
      <Popover open={open} onClose={() => setOpen(false)}>
        <div className="cn-filterbar-sheet-body">{children}</div>
      </Popover>
    </div>
  )
}

export function Fab({ children, ...rest }) {
  return <button className="cn-fab" {...rest}>{children}</button>
}
